import React from "react";

const testimonials = [
  {
    stars: "★★★★★",
    text: "The Hot Stone Massage was absolutely divine. I left feeling like a completely new person. The therapists here are incredibly skilled and attentive.",
    author: "Priya S.",
    role: "Regular Client",
  },
  {
    stars: "★★★★★",
    text: "The Royal H2O Signature experience is worth every rupee. The ambiance, the oils, the attention to detail — this is luxury spa therapy at its finest.",
    author: "Rahul M.",
    role: "Monthly Member",
  },
  {
    stars: "★★★★★",
    text: "I have been coming here for years and the consistency in quality is remarkable. The Balinese massage is my absolute favourite — deeply relaxing.",
    author: "Anjali K.",
    role: "VIP Member",
  },
];

function Testimonials() {
  return (
    <section className="testimonials-section">
      <div style={{ textAlign: "center" }}>
        <div
          className="section-label reveal"
          style={{ justifyContent: "center" }}
        >
          Client Love
        </div>
        <h2 className="section-title reveal">
          What Our <em>Guests Say</em>
        </h2>
      </div>
      <div className="testimonials-wrap">
        {testimonials.map((t, i) => (
          <div className={`testimonial-card reveal stagger-${i + 1}`} key={i}>
            <div className="testimonial-stars">{t.stars}</div>
            <p className="testimonial-text">"{t.text}"</p>
            <div className="testimonial-author">{t.author}</div>
            <div className="testimonial-role">{t.role}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Testimonials;
